export const DEFAULT_TENANT = 'EPI';

// ── Dev flags ─────────────────────────────────────────────────────────────────
export const USE_MOCK_DATA = import.meta.env.VITE_MOCK_EMPLOYEE_DETAIL === 'true';

// ── Navigation layout ─────────────────────────────────────────────────────────
export const NAV_EXPANDED_WIDTH = 260;
export const NAV_COLLAPSED_WIDTH = 70;

// ── Datatable search ──────────────────────────────────────────────────────────
// Delay between the last keystroke and the server-side search request (users and
// rights-profiles lists).
export const SEARCH_DEBOUNCE_MS = 300;

// ── Column configurator ───────────────────────────────────────────────────────
export const DEFAULT_MAX_COLUMNS = 15;
export const WARN_WHEN_COLUMNS_REMAINING_BELOW = 3;

// ── Column minimum widths ─────────────────────────────────────────────────────
// Sticky columns use their value as the exact fixed width (for accurate left offsets).
// Non-sticky columns use these as minWidth floors when fillHeight=false on TableTemplate.
// When fillHeight=true, non-sticky widths are ignored and the browser sizes from content.
export const COLUMN_WIDTH = {
  icon: 90,
  text: 180,
  date: 160,
  boolean: 160,
  number: 160,
  multiValue: 260,
  action: 56,
} as const;
